<template>
  <div>
    <b-loading
        v-model="isLoading"
        :can-cancel="true"
        :is-full-page="true"
    ></b-loading>
    <b-modal v-model="modalActive" width="90%" scroll="keep" style="z-index: 101" @close="clearFields()">
      <div class="modal-card" style="width: auto;">
        <header class="modal-card-head" style="padding: 12px">
          <h6 class="is-size-5 ml-auto mr-auto pl-4 has-text-weight-semibold">Comparable Sites</h6>
          <button
              type="button"
              class="delete"
              @click="show(false, '', deselectOnClose)"/>
        </header>
        <section class="modal-card-body p-0" style="overflow: unset">
          <div class="columns m-0 p-0">
            <div class="column is-4 m-0 p-0">
              <div style="height: 80vh; overflow-y: auto; padding: 12px 4px 8px 4px;">
                <div>
                  <div class="card m-2 p-2" v-for="site in editedSites"
                       :key="site._id">
                    <div class="is-flex is-flex-direction-column">
                      <div class="is-flex is-flex-direction-row" style="background: #ececec">
                        <div class="is-flex is-flex-direction-column mr-auto">
                          <div class="ml-1 p-0 pl-1 pt-1 has-text-weight-semibold">{{ site.name }}</div>
                          <div class="ml-1 p-0 pl-1 pb-1 is-size-7">{{ selectedProject.name }}</div>
                        </div>

                        <b-button class="m-1 mt-auto mb-auto" type="is-ghost" size="is-small"
                                  @click="showSiteOnMap(site)">Show
                        </b-button>
                      </div>

                      <div class="ml-1 mr-0 p-0" v-for="matchingSite in site.matchingSites" :key="matchingSite._id">

                        <div class="is-flex is-flex-direction-row">
                          <div class="is-flex is-flex-direction-column mr-auto">
                            <div class="ml-1 p-0 pl-1 pt-1 has-text-weight-semibold">{{ matchingSite.name }}</div>
                            <div class="ml-1 p-0 pl-1 pb-1 is-size-7">{{ matchingSite.projectName }}</div>
                          </div>
                          <b-checkbox v-model="matchingSite.isMatching" class="mr-0 mt-auto mb-auto"
                                      @input="onMatchingChanged($event,matchingSite)"
                                      native-value="default">
                          </b-checkbox>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="column is-8">
              <g-map-matching-sites ref="gMapInput" v-if="mapType === 'gmap'" style="max-height: 80vh; height: 80vh"
                                    @onMapInputClicked="onMapInputClicked"
                                    @onCoordinatesUpdated="onCoordinatesUpdated"
                                    @onRotationChanged="onRotationChanged"
                                    @onMarkerClicked="onSelectSite"
                                    :is-markers-selectable="true"
                                    :devices="editedSites"
                                    :selected-device="selectedSite"
                                    :selected-project="selectedProject"
                                    :show-edit-location="false"
                                    draw-controls-mode="none"
                                    @onMapClicked="onMapClicked"
              ></g-map-matching-sites>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot" style="padding: 0">
          <b-button class="is-primary is-fullwidth m-2" @click="onUpdateSite" rounded>
            UPDATE COMPARABLE SITES
          </b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {
  getDate, truncate,
} from "@/utils/utils";
import GMapMatchingSites from "@/modules/projects-module/components/g-map-matching-sites/g-map-matching-sites.vue";

export default {
  name: "matching-sites",
  components: {GMapMatchingSites},
  props: {},
  data() {
    return {
      isLoading: false,
      modalActive: false,
      editedSites: null,
      selectedSite: null,
      deselectOnClose: false,
      clickedMarker: false,
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions({
      getLocation: 'getLocationData',
      deselectAllSites: 'projectsModule/deselectAllSites',
      getSitesInRadius: 'projectsModule/getSitesInRadius',
      updateComparableSites: 'projectsModule/updateComparableSites'
    }),
    async show(show, deselectOnClose) {
      this.modalActive = show
      this.deselectOnClose = deselectOnClose
      this.editedSites = null

      if (!this.modalActive) {
        await this.clearFields()
      } else {
        this.isLoading = true
        console.log('Selected project: ', this.selectedProject)
        let response = await this.getSitesInRadius(this.selectedProject._id)
        if (response instanceof Error) {
          this.showToast(response.message, 'is-danger')
          this.isLoading = false
        } else {
          this.isLoading = false
          let sites = []
          response.forEach(item => {
            let site = {...item.site}
            site.objectType = 'site-match'
            site.shortName = truncate(site.name, 15)
            site.color = '#000000'

            site.matchingSites = []

            if (item.matchingSites && item.matchingSites.length > 0) {
              item.matchingSites.forEach(mSite => {
                let siteMatch = JSON.parse(JSON.stringify(mSite))
                siteMatch.objectType = 'site-match-pair'
                siteMatch.shortName = truncate(siteMatch.name, 15)
                siteMatch.projectName = siteMatch.project.name
                siteMatch.color = '#ff0000'
                siteMatch.isMatching = site.comparableSites && site.comparableSites.length > 0 && site.comparableSites.includes(siteMatch._id)

                site.matchingSites.push(siteMatch)

              })
            }

            sites.push(site)
          })

          this.editedSites = sites
          setTimeout(() => {
            this.$refs.gMapInput.zoomMapToSelectedSiteOrProject(false)
          }, 500)

          console.log('Edited sites: ', this.editedSites)
        }

      }
    },
    onSelectSite(event) {
      console.log('On select site: ', event)
    },
    onMatchingChanged(checked, site) {
      console.log('On matching changed: ', checked, site)
      this.zoomToObject(site)
    },
    showSiteOnMap(site) {
      this.zoomToObject(site)
    },
    async onUpdateSite() {
      console.log('Update sites: ', this.editedSites)
      let payload = {
        sites: []
      }

      this.editedSites.forEach(site => {
        let newSite = {
          id: site._id,
          updateBody: {
            comparableSites: []
          }
        }

        if (site.matchingSites && site.matchingSites.length > 0) {
          site.matchingSites.forEach(mSite => {
            if (mSite.isMatching) {
              newSite.updateBody.comparableSites.push(mSite._id)
            }
          })
        }

        payload.sites.push(newSite)

      })

      console.log('Payload Sites: ', payload)
      this.isLoading = true
      let response = await this.updateComparableSites(payload)
      if (response instanceof Error) {
        this.showToast(response.message, 'is-danger')
      } else {
        await this.clearFields()
        this.showToast('Sites successfully updated', 'is-success')
        await this.show(false, true)
        await this.deselectAllSites()
      }
      this.isLoading = false

    },
    async onMapClicked(position) {
      console.log('On map clicked edit devices:', position)
      if (!this.clickedMarker || this.mapType === 'gmap') {
        this.selectedDevice = null
      }
      this.clickedMarker = false
      this.zoomToObject()
    },
    onRotationChanged(data) {
      console.log('On rotation changed', data)
    },
    onMapInputClicked(position) {
      console.log('On map input clicked:', position)
    },
    parseAddress(location) {
    },
    async onCoordinatesUpdated(data) {
      /*      console.log('On update coordinates: ', data)
            this.isLoading = true
            let location = await this.getLocation(data.coordinates)
            this.isLoading = false


            let editedIndex = this.editedSites.findIndex(st => st._id === data.item._id)
            if (editedIndex !== -1) {
              this.editedSites[editedIndex].location.coordinates = [data.coordinates.lng, data.coordinates.lat]
              let parsed = this.parseAddress(location)
              this.editedSites[editedIndex].siteName = parsed.address
              this.editedSites[editedIndex].siteLocationName = parsed.place && parsed.place !== 'unknown' ? parsed.place : parsed.address

              if (this.selectedSite && this.selectedSite._id === this.editedSites[editedIndex]._id) {
                console.log('Device is selected')
                this.selectedSite = this.editedSites[editedIndex]
              }
            }*/
    },
    async clearFields() {
      console.log('Clear fields edit device', this.deselectOnClose)
      if (this.deselectOnClose) {
        await this.deselectAllSites()
        this.selectedSite = null
        this.editedSites = null
      }
    },
    click() {
      console.log('Clcked')
    },
    zoomToObject(site) {
      if (this.$refs.mapBoxInput) {
        this.$refs.mapBoxInput.zoomMapToSelectedSiteOrProject(true)
      } else if (this.$refs.gMapInput) {
        this.$refs.gMapInput.selectSite(site)
      }
    },
    showToast(message, type) {
      this.$buefy.toast.open({
        message: message,
        duration: 3000,
        type: type
      })
    },
    getUserById(id) {
      return this.$store.getters.getUserById(id)
    },
    installationDateString(site) {
      return site.installationDate ? getDate(site.installationDate) : ''
    },
    decommissionDateString(site) {
      return site.decommissionDate ? getDate(site.decommissionDate) : ''
    },
    onInstallDropDownChanged() {
      this.installDropdownKey++
    },
    onDecommissionDropDownChanged() {
      this.decommissionDropdownKey++
    },
    planStatusColor(name) {
      if (this.$store.getters.getSettings) {
        let status = this.$store.getters.getSettings.planStatuses.find(status => status.name === name)
        if (status)
          return status.color
      }

      return '#ffffff'
    },
  },
  computed: {
    ...mapGetters({
      mapType: 'getMapType',
      selectedProject: 'projectsModule/getSelectedProject'
    }),
    users() {
      console.log('Allowed users:', this.$store.getters.getAllowedUsers)
      return this.$store.getters.getAllowedUsers
    }
  }
}
</script>

<style lang="scss" scoped>
.simple-site-card {
  border-radius: 16px;
  background-color: #f7f7f7;
  box-shadow: 0 0.125em 0.125em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 2%);
}

.selected {
  background-color: #e3e3e3;
}

.modal-tab-content {
  height: 30vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 24px;
  padding-right: 16px;
}

.status-indicator {
  border-radius: 4px;
  background: black;
  width: 4px;
  height: 48px;
}

.search-box {
  cursor: pointer;
  background-color: #00000005;
  border-radius: 6px;
  box-shadow: none;
  color: hsl(0deg, 0%, 29%);
  display: block;
  padding: 8px;
  margin-bottom: 8px;
}

</style>